/**
 * @ngdoc Directive
 * @name vrm-header
 * @example
 *
 * <vrm-header ng-model="help" ng-value="true" />
 *
 */

import { HEADER_TYPE_ENHANCED } from '@/constants/header';

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmHeader', vrmHeader);

    /* @ngInject */
    function vrmHeader($log, $rootScope) {

        var definition = {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/header/header.template.html'),
            link: link,
            controller: controller,
            transclude: {
                headerControls: '?headerControls',
                headerRowClass: '?headerRowClass',
                extraRow: '?extraRow',
                headerTitle: '?headerTitle',
                headerTitleTasks: '?headerTitleTasks',
                headerPanels: '?headerPanels',
                pageTitle: '?pageTitle',
                vrmEnhancedSearch: '?vrmEnhancedSearch',
                mobilePageTitle: '?mobilePageTitle',
                mobileHeaderControls: '?mobileHeaderControls',
                titleControls: '?titleControls',
                addButton: '?addButton',
                installation: '?installation',
            },
        };

        return definition;

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         */
        function link($scope, $element, $attr, $controller, $transclude) {
            $scope.headerClass = $attr.headerClass || '';
            $scope.headerRowClass = $attr.headerRowClass || '';
            $scope.headerType = $attr.headerType || '' ;
            $scope.HEADER_TYPE_ENHANCED = HEADER_TYPE_ENHANCED;
        }

        /* @ngInject */
        function controller($scope, $transclude) {
            $scope.hasControls = $transclude.isSlotFilled('headerControls');
            $scope.hasTitle = $transclude.isSlotFilled('headerTitle');
            $scope.hasTitleTasks = $transclude.isSlotFilled('headerTitleTasks');
            $scope.hasMobileTitle = $transclude.isSlotFilled('mobilePageTitle');
            $scope.addButton = $transclude.isSlotFilled('addButton');
            $scope.hasTitleControls = $transclude.isSlotFilled('titleControls')
            $scope.hasMobileHeaderControls = $transclude.isSlotFilled('mobileHeaderControls')
            $scope.state = {
                showMore: false
            };
        }
    }
})();
